$(document).ready(function() {
  console.log('cart func loaded');

  const countdownDate = 'October 6, 2024 23:59:59';

  
  // Toggle to turn the entire functionality on or off
  let isFunctionEnabled = true; // Set to false to disable the function entirely



  

  // Custom format money function to format according to the active currency
  function formatMoney(amount) {
    const lang = getLanguage(); // Get the current language ('en' or 'da')

    // Use specific locale for Danish (da-DK) and English (en-US) for formatting
    return new Intl.NumberFormat(lang === 'da' ? 'da-DK' : 'en-US', {
      style: 'currency',
      currency: Shopify.currency.active,
      minimumFractionDigits: 2,
    }).format(amount);
  }

  // Function to get the language setting from the <html> tag
  function getLanguage() {
    return $('html').attr('lang').toLowerCase(); // Returns 'en' or 'da' or other language codes
  }

  // Function to get the correct translation based on the detected language
  function translateContent(amountNeeded, couponAdded = false) {
    const lang = getLanguage();
    if (lang === 'da') {
      return {
        spendMore: `Brug ${formatMoney(amountNeeded)} mere og få en gratis sweater!</br>`,
        congrats: couponAdded ? `Kupon tilføjet! 🎉 </br> Nyd din gratis sweater.</br>` : `Tillykke! 🎉 </br> Du kan tilføje en gratis sweater til din kurv.</br> <a href="/collections/sweatshirts">Vælg din sweater her</a></br>`,
        countdownText: "Kampagnen slutter om:",
      };
    } else { // Default to English
      return {
        spendMore: `Spend ${formatMoney(amountNeeded)} more to get a free sweater!</br>`,
        congrats: couponAdded ? `Coupon added! 🎉 </br> Enjoy your free sweater.</br>` : `Congratulations! 🎉 </br> You've unlocked a free sweater.</br> <a href="/collections/sweatshirts">Select your sweater here</a></br>`,
        countdownText: "Campaign ends in:",
      };
    }
  }

  // Function to update only the countdown timer text without resetting the surrounding structure
  function updateCountdownText(targetDate) {
    const countdownElement = document.getElementById('countdown');
    if (!countdownElement) return; // Exit if no countdown element is present

    const targetTime = new Date(targetDate).getTime();
    const now = new Date().getTime();
    const distance = targetTime - now;

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    countdownElement.textContent = `${days}d ${hours}h ${minutes}m ${seconds}s`;

    // If the countdown is over, stop the function and hide the section
    if (distance < 0) {
      countdownElement.textContent = "EXPIRED";
      isFunctionEnabled = false; // Disable the entire function
      $('.cart-drawer__custom-section').hide(); // Hide the custom section
      $('.announcement__text').find('.countdown-announcement').remove(); // Hide countdown in announcement bar
    }
  }

  // Function to update the cart drawer progress section
  function updateCartDrawerCustomSection() {
    // If the function is disabled, don't update
    if (!isFunctionEnabled) {
      $('.cart-drawer__custom-section').hide(); // Ensure the section is hidden
      return;
    }

    // Disconnect observer to avoid triggering it during DOM updates
    if (observer) observer.disconnect();

    $.getJSON('/cart.js', function(cart) {
      let freeSweaterThreshold;

      // Set the free sweater threshold based on the active currency
      if (Shopify.currency.active === 'DKK') {
        freeSweaterThreshold = 599; // 599 DKK
      } else if (Shopify.currency.active === 'EUR') {
        freeSweaterThreshold = 80; // 80 EUR
      } else {
        freeSweaterThreshold = 599; // Default to 599 (or you can adjust)
      }

      // Cart total is already in the active currency, calculate without the sweater
      let cartTotalWithoutSweater = 0;
      let hasSweater = false;

      cart.items.forEach(item => {
        if (item.title.toLowerCase().includes('sweat')) {
          hasSweater = true;
        } else {
          cartTotalWithoutSweater += item.line_price / 100; // Convert cents to actual value
        }
      });

      const customSection = $('.cart-drawer__custom-section');
      const progressBar = customSection.find('.progress-bar__fill');
      
      // Determine if the coupon is added or threshold is not met
      const couponAdded = hasSweater && cartTotalWithoutSweater >= freeSweaterThreshold;

      // Get translation based on language
      const translation = translateContent(freeSweaterThreshold - cartTotalWithoutSweater, couponAdded);

      // If the sweater is in the cart and coupon is added, show "Coupon added" and hide the progress bar
      if (couponAdded) {
        customSection.html(`
          ${translation.congrats}
          <div class="countdown-wrapper">
            <span class="countdown-text">${translation.countdownText}</span>
            <span id="countdown"></span>
          </div>
        `);  // Progress bar is hidden by not including it in this HTML
      } else if (hasSweater && cartTotalWithoutSweater < freeSweaterThreshold) {
        // If the sweater is in the cart but the threshold is not met, show progress bar
        customSection.html(`
          <div class="progress-bar">
            <div class="progress-bar__fill" style="width: ${(cartTotalWithoutSweater / freeSweaterThreshold * 100).toFixed(2)}%;"></div>
          </div>
          ${translation.spendMore}
          <div class="countdown-wrapper">
            <span class="countdown-text">${translation.countdownText}</span>
            <span id="countdown"></span>
          </div>
        `);
      } else {
        customSection.show(); // Ensure it's visible if no free sweater

        // Update progress bar only when the progress changes
        const progressPercentage = (cartTotalWithoutSweater / freeSweaterThreshold) * 100;
        if (progressBar.css('width') !== `${progressPercentage.toFixed(2)}%`) {
          progressBar.css('width', `${Math.min(progressPercentage, 100).toFixed(2)}%`);
        }

        // Update text based on cart total without sweater
        if (cartTotalWithoutSweater < freeSweaterThreshold) {
          customSection.html(`
            <div class="progress-bar">
              <div class="progress-bar__fill" style="width: ${progressPercentage.toFixed(2)}%;"></div>
            </div>
            ${translation.spendMore}
            <div class="countdown-wrapper">
              <span class="countdown-text">${translation.countdownText}</span>
              <span id="countdown"></span>
            </div>
          `);
        } else {
          customSection.html(`
            <div class="progress-bar">
              <div class="progress-bar__fill" style="width: 100%;"></div>
            </div>
            ${translation.congrats}
            <div class="countdown-wrapper">
              <span class="countdown-text">${translation.countdownText}</span>
              <span id="countdown"></span>
            </div>
          `);
        }
      }

      // Reconnect the observer after the updates are done
      if (observer) observer.observe(cartDrawer, { childList: true, subtree: true });

      // Ensure only the countdown text is updated, avoiding flickering
      updateCountdownText(countdownDate);
    });
  }

  // Function to append countdown to the announcement bar with translated text
  function updateAnnouncementBar() {
    if (!isFunctionEnabled) return; // If the function is disabled, don't update the announcement bar

    const announcementText = $('.announcement__text');
    // Check if the countdown is already appended
    if (announcementText.find('.countdown-announcement').length === 0) {
      const translation = translateContent(0); // Get translation for countdown text
      announcementText.append(`
        <div class="countdown-announcement">
          <span class="countdown-text">- ${translation.countdownText}</span>
          <span id="countdown-announcement"></span>
        </div>
      `);
    }
  }

  // Function to trigger cart update event manually
  function triggerCartUpdated() {
    const event = new Event('cart:updated');
    document.dispatchEvent(event);
  }

  // Bind the custom cart update event
  document.addEventListener('cart:updated', function(event) {
    updateCartDrawerCustomSection();
    updateAnnouncementBar(); // Ensure countdown is added to the announcement bar
  });

  // Set up MutationObserver to watch for changes in the cart drawer
  const cartDrawer = document.querySelector('.cart-drawer');
  let observer = null;
  if (cartDrawer) {
    observer = new MutationObserver(function(mutationsList) {
      let shouldTriggerUpdate = false;
      mutationsList.forEach(function(mutation) {
        // Check if nodes are added or removed, and avoid unnecessary updates
        if (mutation.addedNodes.length || mutation.removedNodes.length) {
          shouldTriggerUpdate = true;
        }
      });
      if (shouldTriggerUpdate) {
        triggerCartUpdated();
      }
    });

    // Configure observer to watch for changes in child elements
    observer.observe(cartDrawer, { childList: true, subtree: true });
  }

  // Trigger initial cart update
  updateCartDrawerCustomSection();
  updateAnnouncementBar(); // Append the countdown to the announcement bar

  // Set interval to update countdown independently from the cart drawer
  setInterval(function() {
    if (isFunctionEnabled) { // Only update countdown if the function is enabled
      updateCountdownText(countdownDate);

      // Update the countdown in the announcement bar
      const countdownElementAnnouncement = document.getElementById('countdown-announcement');
      if (countdownElementAnnouncement) {
        const targetTime = new Date(countdownDate).getTime();
        const now = new Date().getTime();
        const distance = targetTime - now;

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        countdownElementAnnouncement.textContent = `${days}d ${hours}h ${minutes}m ${seconds}s`;

        // If the countdown is over, remove the countdown in the announcement bar
        if (distance < 0) {
          countdownElementAnnouncement.textContent = "EXPIRED";
          $('.countdown-announcement').remove(); // Remove the countdown in the announcement bar
        }
      }
    }
  }, 1000);
});
